import gql from "graphql-tag";

export const SEND_APP_USAGE_STATS = gql`
    mutation SendAppUsageStats($sessionId: String!, $projectRef: ID, $event: AppUsageStatsEvent!) {
        sendAppUsageStats(sessionId: $sessionId, projectRef: $projectRef, event: $event)
    }
`;
